




































































import { Component, Vue, Mixins, Prop, Watch } from 'vue-property-decorator';
import UserMixin from '@/mixins/UserMixin';
import EditViewMixin from '@/mixins/EditViewMixin';
import DeviceViewMixin from '@/mixins/DeviceViewMixin';
import PromiseLoaderMixin from '@/mixins/PromiseLoaderMixin';

import TopMenu from '@/components/TopMenu.vue';
import FooterMenu from '@/components/FooterMenu.vue';
import ScalableBackground from '@/components/ScalableBackground.vue';
import FloorplanButton from '@/components/FloorplanButton.vue';

import { State, Getter, Action, Mutation } from 'vuex-class';

import ApiProvider from '@/common/apis/ApiProvider';

import { Client, UploadFileAsJsonRequest, GetFileAsBytesResponse } from '@/common/apis/DeviceApi';
import { IFloorplanButton, IFloorplanButtonWithRelay } from '../../store/views/floorplanView/types';
import { XamarinAdapter } from '../../common/XamarinAdapter';
import getLogger from '@/common/logging/Logger';


@Component({
    components: {
        TopMenu,
        FooterMenu,
        ScalableBackground,
        FloorplanButton,
    },
})
export default class Floorplan extends Mixins(UserMixin, EditViewMixin, DeviceViewMixin, PromiseLoaderMixin) {

    public loading: boolean = true;
    public imageBase64: string = '';
    public selected: number = -1;
    public savingImage: boolean = false;

    private logger = getLogger('floorplan');

    public get buttons(): IFloorplanButtonWithRelay[] {
        return this.getButtons && this.deviceNumber
            ? this.getButtons(this.deviceNumber)
            : [];

    }

    @Getter('floorplanView/buttons')
    private getButtons?: (deviceNumber: string) => IFloorplanButtonWithRelay[];

    @Mutation('floorplanView/setPosition')
    private setButtonPosition?: (args: {deviceNumber: string, buttonIndex: number, x: number, y: number }) => void;


    @Mutation('floorplanView/addButton')
    private viewAddButton: (args: {deviceNumber: string}) => void;

    public onButtonMoved(buttonIndex: number, args: {x: number, y: number}) {
        if (this.deviceNumber && this.setButtonPosition) {
            this.setButtonPosition({
                deviceNumber: this.deviceNumber,
                buttonIndex,
                x: args.x,
                y: args.y,
            });
            this.selected = buttonIndex;
        }
    }

    public openEdit() {
        (this.$refs['button_' + this.selected]as any)[0].openEdit();
    }

    public addButton() {
         if (this.deviceNumber) {
             this.viewAddButton({deviceNumber: this.deviceNumber});
             this.selected = this.buttons.length - 1;
             this.$nextTick(() => {
                this.openEdit();
             });
         }
    }

    public async cameraClick() {
        try {
            this.loading = true;
            if (XamarinAdapter.isXamarin()) {
                const api = ApiProvider.getDeviceApi();
                this.savingImage = true;
                await api.startCamera(this.deviceNumber);
                await this.loadImage(true);
            } else {
                alert('Not yet available from web');
                // Todo :)
                // (this.$refs.file as HTMLElement).click();
            }
        } catch (e) {
            this.logger.error('error using camera', e);
        }
        this.savingImage = false;
        this.loading = false;
    }

    public startEditing(): void {
        this.isEditing = true;
    }
    public async saveEditing(): Promise<any> {
        this.loading = true;
        try {
            await this.$store.dispatch('floorplanView/pushToViews', {deviceNumber: this.deviceNumber});
            await this.$store.dispatch('views/upload', {deviceNumber: this.deviceNumber});
            this.isEditing = false;
            this.loading = false;
        } catch (e) {
            this.loading = false;
        }
    }
    public async undoEdititing() {
        this.loading = true;
        this.loading = false;
        this.isEditing = false;
    }

    public async created() {
        if (!this.verifyLoginStatus(true)) {
            return;
        }
        // await this.$store.dispatch('views/uploadFakeContent', { deviceNumber: this.deviceNumber });
        await this.loadPromises([
            {name: 'floorplanView/loadImage', promise: () => this.loadImage() },
            {name: 'floorplanView/load', promise: () => this.$store.dispatch('floorplanView/load', { deviceNumber: this.deviceNumber })},
            {name: 'relaysView/load', promise: () => this.$store.dispatch('relaysView/load', { deviceNumber: this.deviceNumber })},
            {name: 'relays/load', promise: () => this.$store.dispatch('relays/load', { deviceNumber: this.deviceNumber })},
        ]);

        this.loading = false;
    }

    private async loadImage(force?: boolean) {
        try {
            const  result = await this.$store.dispatch('floorplanView/loadImage', { deviceNumber: this.deviceNumber, force });
            this.imageBase64 = 'data:image/jpg;base64,' + result.content;
            // console.log('image', this.imageBase64);
        } catch (e) {
            // No need to retry if file was not found
            if (e.message.indexOf('File not found') > -1) {
                return;
            }
            throw e;
        }
    }

}


